import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["field"]

  connect() {
  }

  disconnect() {
  }

  clear() {
    this.fieldTargets.forEach((element) => {
      console.log(element)
      element.value = ""
    });
  }

}